import { createAsyncThunk } from "@reduxjs/toolkit";
import Api from "../../BaseUrlConfigration/ApiConfig";

export const getConfigureColorsAction = createAsyncThunk(
  "configureColor/getColors",
  async (_, thunkAPI) => {
    try {
      const response = await Api.get("/configure-colors/get_colors");
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data || error.message);
    }
  }
);

export const addConfigureColorsAction = createAsyncThunk(
  "configureColor/addColors",
  async (reqBody, thunkAPI) => {
    try {
      const endpoint = Api.defaults.baseURL?.endsWith("/admin")
        ? "/configure-colors/add_colors"
        : "/admin/configure-colors/add_colors";
      const response = await Api.post(endpoint, reqBody);
      return response.data;
    } catch (error) {
      if (error?.response?.status === 404) {
        try {
          const fallbackEndpoint = Api.defaults.baseURL?.endsWith("/admin")
            ? "/admin/configure-colors/add_colors"
            : "/configure-colors/add_colors";
          const fallbackResponse = await Api.post(fallbackEndpoint, reqBody);
          return fallbackResponse.data;
        } catch (err) {
          return thunkAPI.rejectWithValue(err?.response?.data || err.message);
        }
      }
      return thunkAPI.rejectWithValue(error?.response?.data || error.message);
    }
  }
);

export const editConfigureColorsAction = createAsyncThunk(
  "configureColor/editColors",
  async (reqBody, thunkAPI) => {
    try {
      const endpoint = Api.defaults.baseURL?.endsWith("/admin")
        ? "/configure-colors/edit_colors"
        : "/admin/configure-colors/edit_colors";
      const response = await Api.patch(endpoint, reqBody);
      return response.data;
    } catch (error) {
      if (error?.response?.status === 404) {
        try {
          const fallbackEndpoint = Api.defaults.baseURL?.endsWith("/admin")
            ? "/admin/configure-colors/edit_colors"
            : "/configure-colors/edit_colors";
          const fallbackResponse = await Api.patch(fallbackEndpoint, reqBody);
          return fallbackResponse.data;
        } catch (err) {
          return thunkAPI.rejectWithValue(err?.response?.data || err.message);
        }
      }
      return thunkAPI.rejectWithValue(error?.response?.data || error.message);
    }
  }
);

export const resetConfigureColorsAction = createAsyncThunk(
  "configureColor/resetColors",
  async (reqBody = {}, thunkAPI) => {
    try {
      const endpoint = Api.defaults.baseURL?.endsWith("/admin")
        ? "/configure-colors/reset_colors"
        : "/admin/configure-colors/reset_colors";
      const response = await Api.post(endpoint, reqBody);
      return response.data;
    } catch (error) {
      if (error?.response?.status === 404) {
        try {
          const fallbackEndpoint = Api.defaults.baseURL?.endsWith("/admin")
            ? "/admin/configure-colors/reset_colors"
            : "/configure-colors/reset_colors";
          const fallbackResponse = await Api.post(fallbackEndpoint, reqBody);
          return fallbackResponse.data;
        } catch (err) {
          return thunkAPI.rejectWithValue(err?.response?.data || err.message);
        }
      }
      return thunkAPI.rejectWithValue(error?.response?.data || error.message);
    }
  }
);

export const getColorsAction = getConfigureColorsAction;
export const addColorsAction = addConfigureColorsAction;
export const editColorsAction = editConfigureColorsAction;
export const resetColorsAction = resetConfigureColorsAction;
